<template>
    <div>
        <!-- 选择链接类型弹窗 -->
        <van-popup v-if="showLinkTypePopup" v-model="showCourseLinkAddType" position="center" round class="share-type-popup" :style="{ height: '300px' }">
            <div class="popup-content">
                <div class="popup-title">选择链接生成类型</div>
                <div class="radio-group">
                    <van-radio-group v-model="course_link_add_type" direction="vertical">
                        <van-radio name="1" class="radio-item">看课链接</van-radio>
                        <van-radio name="2" class="radio-item">进粉链接</van-radio>
                    </van-radio-group>
                </div>
                <div class="popup-footer">
                    <div class="btn cancel" @click="onCourseLinkAddTypeCancel">
                        取消
                    </div>
                    <div class="btn confirm" @click="onCourseLinkAddTypeConfirm">
                        确认
                    </div>
                </div>
            </div>
        </van-popup>
        
        <!-- 分享选项遮罩层 -->
        <div v-show="showShare" @click="onShareClose" class="share-mask"></div>
        
        <!-- 分享选项弹窗 -->
        <div v-show="showShare" class="share-options">
            <div class="share-options-content">
                <div 
                    v-for="(item, index) in options" 
                    :key="'share_' + index" 
                    :id="'share' + index"
                    :data-clipboard-text="item.link_data && item.link_data.url ? item.link_data.url : ''" 
                    class="share-option-item"
                    @click="handleCopy(
                        item,
                        item.link_data && item.link_data.url ? item.link_data.url : '',
                        'share' + index,
                        item.title,
                        item.video_image,
                        item.miniAppId,
                        item.pages
                    )"
                >
                    <img :src="item.image" alt="" class="share-icon" />
                    <div class="share-name">{{ item.name }}</div>
                </div>
                <!-- 自动发课选项 -->
                <div 
                    v-if="showRobot"
                    class="share-option-item"
                    @click="onRobotClick"
                >
                    <img 
                        src="https://filevideo.shengjingrenai.com/uploads/20251018/38b030366ea40179bc892e895683edce.png" 
                        alt="" 
                        class="share-icon" 
                    />
                    <div class="share-name">自动发课</div>
                </div>
            </div>
            <div class="share-cancel" @click="onShareClose">取消</div>
        </div>

        <!-- 二维码海报弹窗 -->
        <van-popup v-model="showQrcode" position="center" round @close="showQrcode = false">
            <div class="qrcode-content">
                <img :src="shareQrcode" alt="分享二维码" class="qrcode-img" ref="qrcodeImg">
                <div class="qrcode-btn">长按图片保存到手机</div>
            </div>
        </van-popup>
    </div>
</template>

<script>
import { Popup, RadioGroup, Radio, Toast, Dialog } from 'vant';
import { createCourseSharingLink } from '@/api/course';
import { liveRoomCreateCourseSharingLink } from '@/api/live';
import Clipboard from 'clipboard';
import QRCode from 'qrcode';

export default {
    name: 'CourseShare',
    components: {
        VanPopup: Popup,
        VanRadioGroup: RadioGroup,
        VanRadio: Radio
    },
    props: {
        // 用户信息，用于生成海报
        userInfo: {
            type: Object,
            default: () => ({})
        },
        // 是否显示"自动发课"选项
        showRobot: {
            type: Boolean,
            default: false
        },
        // 是否显示链接类型选择弹窗，false 时调用 show() 直接跳过选择步骤
        showLinkTypePopup: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            showShare: false,
            showQrcode: false,
            showCourseLinkAddType: false,
            course_link_add_type: '1',
            selectKcItem: null,
            options: [],
            shareQrcode: '',
            // 分享场景：决定 item.type 的含义映射（课程 vs 直播可能相同数字但语义不同）
            shareScene: 'course', // 'course' | 'live'
        };
    },
    methods: {
        /**
         * 显示分享弹窗
         * @param {Object} courseItem - 课程信息对象
         * @param {String} courseItem.train_lesson_id - 课程ID
         * @param {String} courseItem.lesson_title - 课程标题
         * @param {String} courseItem.path_url - 课程路径
         * @param {String} courseItem.video_image - 课程封面
         */
        show(courseItem) {
            if (!courseItem || !courseItem.train_lesson_id) {
                Toast.fail('课程信息不完整');
                return;
            }
            this.shareScene = 'course';
            this.selectKcItem = courseItem;
            if (this.showLinkTypePopup) {
                this.showCourseLinkAddType = true;
            } else {
                this.onCourseLinkAddTypeConfirm();
            }
        },

        /**
         * 显示直播分享弹窗
         * @param {Object} liveItem - 直播信息对象（至少包含 id/name）
         * @param {Number|String} live_channel_type - 直播频道类型
         */
        async showLive(liveItem, live_channel_type) {
            if (!liveItem || !liveItem.id) {
                Toast.fail('直播信息不完整');
                return;
            }
            this.shareScene = 'live';

            this.selectKcItem = {
                lesson_title: liveItem.name || liveItem.lesson_title || liveItem.train_name || '',
                path_url: liveItem.path_url || '',
                video_image: liveItem.cover || liveItem.video_image || '',
            };

            this.options = [];
            this.showCourseLinkAddType = false;

            const loading = Toast.loading({
                message: '正在生成分享链接...',
                forbidClick: true,
                duration: 0,
            });

            try {
                const res = await liveRoomCreateCourseSharingLink({
                    liveId: liveItem.id,
                    live_channel_type: live_channel_type,
                });

                loading.clear();

                if (res && res.code == 1 && Array.isArray(res.data)) {
                    this.options = res.data;
                } else if (res && Array.isArray(res.data)) {
                    this.options = res.data;
                } else {
                    Toast.fail((res && res.msg) || '链接生成失败，请重试');
                    return;
                }

                this.options.forEach((e) => {
                    if (!e.title && this.selectKcItem.lesson_title) e.title = this.selectKcItem.lesson_title;
                    if (!e.path_url && this.selectKcItem.path_url) e.path_url = this.selectKcItem.path_url;
                    if (!e.video_image && this.selectKcItem.video_image) e.video_image = this.selectKcItem.video_image;
                });

                setTimeout(() => {
                    this.showShare = true;
                    this.showShare = false;
                    this.showShare = true;
                }, 100);
            } catch (error) {
                loading.clear();
                Toast.fail('链接生成失败，请重试');
                console.error('直播链接生成失败:', error);
            }
        },


        // 确认选择链接类型，生成分享链接
        async onCourseLinkAddTypeConfirm() {
            this.showCourseLinkAddType = false;
            this.options = [];
            
            // 显示加载提示
            const loading = Toast.loading({
                message: '正在生成分享链接...',
                forbidClick: true,
                duration: 0,
            });
            
            try {
                const res = await createCourseSharingLink({
                    train_lesson_id: this.selectKcItem.train_lesson_id,
                    validity_time: '100',
                    course_link_add_type: this.course_link_add_type,
                });
                
                // 关闭加载提示
                loading.clear();
                
                if (res.data && Array.isArray(res.data)) {
                    // 检查是否有生成失败的情况
                    let flag = false;
                    let retry_message = '';
                    res.data.forEach((e) => {
                        if (e.type == 6 && e.retry_count > 0) {
                            flag = true;
                            retry_message = e.retry_count_message;
                        }
                    });
                    
                    if (flag) {
                        Dialog.confirm({
                            title: '提示',
                            message: retry_message || '链接生成失败,请重新点击获取',
                            confirmButtonText: '确认',
                            showCancelButton: false
                        });
                        return;
                    }
                }
                
                this.options = res.data;
                this.options.forEach((e) => {
                    e.title = this.selectKcItem.lesson_title;
                    e.path_url = this.selectKcItem.path_url;
                    e.video_image = this.selectKcItem.video_image;
                });
                
                // 显示分享选项
                setTimeout(() => {
                    this.showShare = true;
                    this.showShare = false;
                    this.showShare = true;
                }, 100);
            } catch (error) {
                // 出错时也要关闭加载提示
                loading.clear();
                Toast.fail('链接生成失败，请重试');
                console.error('链接生成失败:', error);
            }
        },

        // 取消选择链接类型
        onCourseLinkAddTypeCancel() {
            this.showCourseLinkAddType = false;
        },

        // 点击自动发课
        onRobotClick() {
            this.onShareClose();
            this.$router.push('/robot/labels');
        },
        
        // 关闭分享选项
        onShareClose() {
            this.showShare = false;
        },

        /**
         * 处理复制操作
         * @param {Object} item - 分享项数据
         * @param {String} url - 分享链接
         * @param {String} id - 元素ID
         * @param {String} title - 标题
         * @param {String} image - 图片
         * @param {String} miniAppId - 小程序ID
         * @param {String} pages - 页面路径
         */
        handleCopy(item, url, id, title, image, miniAppId, pages) {
            const itemType = String(item && item.type ? item.type : '');

            const normalCopy = () => {
                // 普通链接复制
                const that = this;
                let clipBoard = new Clipboard(`#${id}`);
                clipBoard.on('success', function () {
                    clipBoard.destroy(); // 销毁上一次的复制内容
                    clipBoard = new Clipboard(`#${id}`);
                    that.$toast.success('复制成功');
                });
                clipBoard.on('error', function () {
                    that.$dialog.confirm({
                        title: '复制提示',
                        message: '链接生成失败，请重新点击获取',
                        confirmButtonText: '我知道了',
                    });
                });
            };

            const tryCreatedCanvasPoster = () => {
                const qrBase64 = item.link_data && item.link_data.url_base64;
                const posterBgBase64 =
                    item.poster_data && item.poster_data.poster_background_image_base64;
                if (qrBase64 && posterBgBase64) {
                    this.createdCanvas(qrBase64, posterBgBase64);
                    return true;
                }
                return false;
            };

            const tryCreateQrcode = () => {
                // 二维码海报：link_data.url + poster_data.poster_background_image_base64
                const qrUrl = item.link_data && item.link_data.url;
                const posterBgBase64 =
                    item.poster_data && item.poster_data.poster_background_image_base64;
                if (qrUrl && posterBgBase64) {
                    this.createQrcode(qrUrl, posterBgBase64);
                    return true;
                }
                return false;
            };
            if (this.shareScene === 'course') {
                // 课程：12/13/14 海报，15 二维码
                if (itemType === '12' || itemType === '13' || itemType === '14') {
                    if (tryCreatedCanvasPoster()) return;
                }
                if (itemType === '15') {
                    if (tryCreateQrcode()) return;
                }
                normalCopy();
                return;
            }

            // 直播
            if (this.shareScene === 'live') {
                normalCopy();
                return;
            }

            // 默认兜底
            normalCopy();
        },

        /**
         * 创建海报画布
         * @param {String} qr_base64 - 二维码base64
         * @param {String} poster_bg_base64 - 海报背景base64
         */
        createdCanvas(qr_base64, poster_bg_base64) {
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');
            const posterImg = new Image();
            posterImg.src = poster_bg_base64;
            
            posterImg.onload = () => {
                canvas.width = posterImg.width;
                canvas.height = posterImg.height;
                ctx.drawImage(posterImg, 0, 0, canvas.width, canvas.height);
                
                const qrImg = new Image();
                qrImg.src = qr_base64;
                
                qrImg.onload = () => {
                    // 绘制二维码
                    const qrWidth = canvas.width * 2 / 3;
                    const qrHeight = qrWidth;
                    const qrX = (canvas.width - qrWidth) / 2;
                    const qrY = (canvas.height - qrHeight) / 2;
                    ctx.drawImage(qrImg, qrX, qrY, qrWidth, qrHeight);
                    
                    // 添加文字
                    ctx.font = '48px Arial';
                    ctx.fillStyle = '#000000';
                    ctx.textAlign = 'center';
                    ctx.textBaseline = 'middle';
                    ctx.fillText('长按识别二维码开始学习', canvas.width / 2, canvas.height - 60);
                    
                    // 添加用户名（如果有）
                    if (this.userInfo && this.userInfo.name) {
                        ctx.fillText(this.userInfo.name, canvas.width / 2, canvas.height * 0.83);
                    }
                    
                    // 添加课程标题
                    if (this.selectKcItem && this.selectKcItem.lesson_title) {
                        ctx.fillText(this.selectKcItem.lesson_title, canvas.width / 2, canvas.height * 0.2);
                    }
                    
                    const imgData = canvas.toDataURL('image/png');
                    this.shareQrcode = imgData;
                    this.showQrcode = true;
                };
                
                qrImg.onerror = () => {
                    Toast.fail('二维码生成失败，请重试');
                };
            };
            
            posterImg.onerror = () => {
                Toast.fail('海报背景生成失败，请重试');
            };
        },

        /**
         * 生成二维码
         * @param {String} url - 链接地址
         * @param {String} poster_bg_base64 - 海报背景base64
         */
        createQrcode(url, poster_bg_base64) {
            QRCode.toDataURL(url).then(data => {
                this.createdCanvas(data, poster_bg_base64);
            }).catch(err => {
                Toast.fail('二维码生成失败，请重试');
            });
        }
    }
};
</script>

<style lang="less" scoped>
// 链接类型选择弹窗
.share-type-popup {
    .popup-content {
        padding: var(--base-px-20);
        min-width: 70vw;
        display: flex;
        flex-direction: column;
        height: 100%;
    }
    
    .popup-title {
        font-size: var(--base-px-18);
        font-weight: bold;
        color: #333333;
        text-align: center;
        margin-bottom: var(--base-px-24);
    }
    
    .radio-group {
        flex: 1;
        
        /deep/ .van-radio {
            margin-bottom: var(--base-px-16);
        }
        
        .radio-item {
            font-size: var(--base-px-16);
            padding: var(--base-px-12) 0;
        }
    }
    
    .popup-footer {
        display: flex;
        gap: var(--base-px-12);
        padding-top: var(--base-px-16);
        
        .btn {
            flex: 1;
            height: var(--base-px-44);
            border-radius: var(--base-px-8);
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: var(--base-px-16);
            cursor: pointer;
            
            &.cancel {
                background: #f5f5f5;
                color: #666666;
            }
            
            &.confirm {
                background: #1989fa;
                color: #ffffff;
            }
        }
    }
}

// 分享选项遮罩
.share-mask {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 98;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.7);
}

// 分享选项弹窗
.share-options {
    min-height: 20%;
    border-radius: var(--base-px-16) var(--base-px-16) 0px 0px;
    z-index: 2002;
    bottom: 0;
    left: 0;
    width: 100%;
    position: fixed;
    max-height: 100%;
    overflow-y: auto;
    background-color: #fff;
    transition: transform 0.3s, -webkit-transform 0.3s;
}

// 取消按钮
.share-cancel {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: var(--base-px-14);
    color: #333333;
    padding-bottom: var(--base-px-24);
    cursor: pointer;
}

.share-options-content {
    width: 100%;
    padding: var(--base-px-12);
    display: flex;
    justify-content: center;
    align-items: center;
}

.share-option-item {
    width: 25%;
    display: flex;
    align-items: center;
    flex-direction: column;
    cursor: pointer;
}

.share-icon {
    width: var(--base-px-48);
    height: var(--base-px-48);
}

.share-name {
    margin-top: var(--base-px-8);
    color: #646566;
    font-size: var(--base-px-12);
    text-align: center;
}

// 二维码海报
.qrcode-content {
    padding: var(--base-px-20);
    display: flex;
    flex-direction: column;
    align-items: center;
}

.qrcode-img {
    max-width: 80vw;
    max-height: 70vh;
    border-radius: var(--base-px-8);
}

.qrcode-btn {
    margin-top: var(--base-px-16);
    font-size: var(--base-px-14);
    color: #666666;
    text-align: center;
}
</style>
